import { FirebaseError } from 'firebase/app';

export function ErrorHandling(error: FirebaseError) {
  switch (error.code) {
    case 'auth/email-already-in-use':
      return 'email-already-exists';
    case 'auth/weak-password':
      return 'auth_weak_password';
    default:
      return error.message.split('Firebase: ').join(' ')
  }
}
